@if (mode === 'large') {
  <button [matMenuTriggerFor]="lang" mat-button>
    <mat-icon class="mr2">language</mat-icon>
    <span>{{ (language$ | async)?.name.substr(0, 2) | uppercase }}</span>
  </button>
} @else {
  <button [matMenuTriggerFor]="lang" mat-icon-button>
    <mat-icon matListItemIcon [svgIcon]="(language$ | async)?.name"></mat-icon>
  </button>
}
<mat-menu #lang="matMenu">
  <mat-nav-list dense>
    @for (item of languageList; track item) {
      <a mat-list-item [href]="getHref(item.id)">
        <mat-icon matListItemIcon [svgIcon]="item.name"></mat-icon>
        <span matListItemTitle>{{ item.name }}</span>
      </a>
    }
  </mat-nav-list>
</mat-menu>